export default __webpack_public_path__ + "static/media/24.ece8c19d.jpg";